// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__rwCiC","selected":"Chip_selected__3Zr4T"};